import { css } from "@linaria/core";
import React from "react";
import { styled } from "@linaria/react";
import { colors } from "@ui/Theme";

const chartTooltipsCss = css`
  min-width: 300px;
  max-width: 350px;
  display: flex;
  flex-direction: column;
  padding: 6px;
  white-space: initial;

  & > *:not(:first-child) {
    margin-top: 8px;
    padding-top: 8px;
    border: none;
    border-top: 1px solid ${colors.titanium200};
  }
`;

export const Action = styled.a`
  white-space: inherit;
  text-decoration-line: underline;
  color: ${colors.carbon900};
  cursor: pointer;
  :hover {
    &.confirm {
      color: ${colors.lightNitrogen600};
    }
    &.danger {
      color: ${colors.error};
    }
  }
`;

export const ChartTooltip = ({ children }: { children: React.ReactNode }) => (
  <div className={chartTooltipsCss}>{children}</div>
);
